import i18n from "@/lib/i18n";
import Tabs from "@/components/UsersGroupsTabs.vue";

export const config = {
  name: "childrenGroups",
  route: "/childrenGroups",
  store: "childrenGroups",

  model: [{ id: "name", label: i18n.t("Group name"), searchable: true }],

  pages: {
    icon: "fa-user-friends",

    list: {
      actions: [
        {
          title: i18n.t("pages.childrenGroups.add"),
          route: "childrenGroups.create",
        },
      ],

      quickFilters: Tabs,
    },
  },
};
